module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/pencil-417808c3991f1e81817eb5100a5f83e8.svg";